import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ToastM } from '../interfaces/toast.interface';

@Injectable({
  providedIn: 'root',
})
export class TrigerToastService {
  private showToastSubject = new BehaviorSubject<ToastM | null>(null);
  constructor() {}

  showToast(data: ToastM) {
    if (data) {
      this.showToastSubject.next(data);
    }
  }

  getToastMessage() {
    return this.showToastSubject.asObservable();
  }
}
